import { BlockStack, Box } from '@shopify/polaris'
import { useTranslation } from 'react-i18next'

import RegularText from '@/components/RegularText'
import AppModal from '../../../../components/AppModal/AppModal'
import { SubmitTone, TypeDelete } from '@/constants/enum'

type TModalDeleteLocation = {
  isShowModal: boolean
  selectedLocationId: number
  typeDelete: TypeDelete
  handleConfirmDelete: (id: number) => void
  onCancel: () => void
  loading?: boolean
}

const ModalDeleteLocations = ({
  isShowModal,
  selectedLocationId,
  typeDelete,
  onCancel,
  handleConfirmDelete,
  loading
}: TModalDeleteLocation) => {
  const { t } = useTranslation('locations')

  return (
    <AppModal
      title={`Delete ${typeDelete}`}
      open={isShowModal}
      onCancel={onCancel}
      submitTone={SubmitTone.CRITICAL}
      onSubmit={() => handleConfirmDelete(selectedLocationId)}
      submitText={t('modalDelete.confirm')}
      cancelText={t('modalDelete.cancel')}
      loading={loading}
    >
      <Box padding={'400'}>
        <BlockStack gap={'400'}>
          <RegularText>
            {`Deleting this ${typeDelete} will erase all settings`} and <strong>cannot be undone</strong>.{' '}
          </RegularText>
        </BlockStack>
      </Box>
    </AppModal>
  )
}

export default ModalDeleteLocations
